import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { AccountSettings } from "@/components/settings/account-settings";
import { ActiveSessions } from "@/components/settings/active-sessions";
import { ChangePasswordSection } from "@/components/settings/change-password";
import { DangerZone } from "@/components/settings/danger-zone";
import { TwoFactorSettings } from "@/components/settings/two-factor-settings";
import { signInMethodsQuery } from "@/lib/loaders";

export const Route = createFileRoute("/_workspace/settings/account")({
  loader: ({ context }) => context.queryClient.ensureQueryData(signInMethodsQuery),
  component: SettingsAccountPage,
});

function SettingsAccountPage() {
  const { data: signInMethods } = useQuery(signInMethodsQuery);
  // `true` is the safer default when the lookup failed: it shows the
  // change-password UI rather than offering to set a password on an account
  // that already has one.
  const hasPassword = signInMethods?.hasPassword ?? true;

  return (
    <div className="flex flex-col gap-10">
      <AccountSettings />
      <ChangePasswordSection hasPassword={hasPassword} />
      <TwoFactorSettings hasPassword={hasPassword} />
      <ActiveSessions />
      <DangerZone />
    </div>
  );
}
